/* eslint-disable camelcase */
/* eslint-disable promise/always-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react'
import { createEmbeddingContext } from 'amazon-quicksight-embedding-sdk'
import Axios from '../../Config/Axios'
import { useMenu, useAuth, useSubscription } from '../../Global'
import { Hidden, IconButton } from '@material-ui/core'
import FullscreenIcon from '@material-ui/icons/Fullscreen'
import FullscreenExitIcon from '@material-ui/icons/FullscreenExit'
import '../../App.css'
import SkeletonDashboard from '../SkeletonDashboard'
import { useStyles } from './TargetsDashboard.styles'


function TargetsDashboard() {
  const divRef = useRef()
  const classes = useStyles()
  const { getUpdatedUser, targetsDashboardId } = useAuth()
  const { isFullScreen, toggleFullScreen } = useMenu()
  const { refetchSubscription } = useSubscription()
  const [isLoading, setLoading] = useState(true)
  const [embedUrl, setEmbedUrl] = useState(null)

  const embedDashboard = async(url) => {
    const container = document.getElementById('containerDashboardTargets')
    if (!container) return

    const embeddingContext = await createEmbeddingContext({
      onChange: (changeEvent, metadata) => {
        console.log('Context received a change', changeEvent, metadata)
      },
    })

    const frameOptions = {
      url: url,
      container,
      height: '100%',
      width: '100%',
      className: 'quicksight-embedding-iframe-target',
      onChange: (changeEvent, metadata) => {
        switch (changeEvent.eventName) {
        case 'FRAME_MOUNTED': {
          console.log('Do something when the experience frame is mounted.')
          break
        }
        case 'FRAME_LOADED': {
          console.log('Do something when the experience frame is loaded.')
          break
        }
        }
      },
    }

    const contentOptions = {
      toolbarOptions: {
        export: true,
        undoRedo: true,
      },
    }

    await embeddingContext.embedDashboard(frameOptions, contentOptions)
  }

  useEffect(() => {
    getUpdatedUser()
    // refetchSubscription()    
  }, [])

  useEffect(() => {
    let isMounted = true

    Axios({
      method: 'GET',
      url: `/prod/user/dashboard/${targetsDashboardId}`,
    })
      .then((response) => {
        if (isMounted) {
          setEmbedUrl(response?.data?.EmbedUrl)
          setLoading(false)
        }
      })
      .catch(() => {
        if (isMounted) {
          setLoading(false)
        }
      })

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (!isLoading && embedUrl) {
      embedDashboard(embedUrl)
    }
  }, [isLoading, embedUrl])

  return (
    <>
      {isLoading ? (
        <SkeletonDashboard target={true} />
      ) : (
        <div
          className={
            isFullScreen ? classes.dashboardFullScreen : classes.dashboard
          }
        >
          <Hidden xsDown>
            <IconButton
              disableFocusRipple
              centerRipple={true}
              classes={{
                root: isFullScreen
                  ? classes.iconButtonFull
                  : classes.iconButton,
              }}
              onClick={toggleFullScreen}
            >
              {isFullScreen ? (
                <FullscreenExitIcon classes={{ root: classes.rootBackIcon }} />
              ) : (
                <FullscreenIcon classes={{ root: classes.rootBackIcon }} />
              )}
            </IconButton>
          </Hidden>

          <div ref={divRef} id='containerDashboardTargets' style={{ flex: 2 }} />
        </div>
      )}
    </>
  )
}

export default TargetsDashboard